import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
import { AuthService } from 'app/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class WebCompProfileService {

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  getUrlWebComProfile(empresaId:any, lang:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getUrlWebComProfile + localStorage.getItem('companyID')+'/'+lang);
  }



  getStatusWebComProfile(productoId:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getWebCompanyProfileVisibility + localStorage.getItem('companyID')+'/'+productoId);
  }

  updateStatusNoPublicWebComProfile(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.updateWebCompanyProfileVisibility + localStorage.getItem('companyID'),datos);
  }

  getdataWPCExt(empresaId:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getdataWPCExt + empresaId);
  }

  getUrlWebComProfileExterno(empresaId:any, lang:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getUrlWebComProfileExterno + empresaId+'/'+lang);
  }

  getGuideLineWCP(instituto:any, lang:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.GuideLineWCP + instituto+'/'+lang);
  }

  getBadgeWPC(token:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getBadgeWPC + token);
  }

}
